import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

type DirectionalArrowProps = {
  className?: string;
};

export default function DirectionalArrow({ className }: DirectionalArrowProps) {
  return (
    <ArrowRight
      className={cn(
        "rtl:rotate-180",
        "transition-transform group-hover/button:translate-x-0.5 group-hover:translate-x-0.5 rtl:group-hover/button:-translate-x-0.5 rtl:group-hover:-translate-x-0.5 rtl:group-hover:-translate-x-0.5",
        className,
      )}
      aria-hidden
    />
  );
}
